/*
* state
* */
import storage from './storage'

export default {
  login: storage.getSession('login'), // 是否登录
  token: storage.getSession('token'), // 登录用户id
  userInfo: storage.getItem('userInfo'),
  menu: storage.getItem('menu')
}



// WEBPACK FOOTER //
// ./src/store/state.js